<ng-container [ngSwitch]="statusNumber">
  <ng-container
    *ngSwitchCase="20"
    [ngTemplateOutlet]="changeOrderTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="7"
    [ngTemplateOutlet]="insideSalesTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchDefault
    [ngTemplateOutlet]="customerVisitTemplate"
  ></ng-container>
</ng-container>

<ng-template #customerVisitTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Customer Visits</mat-label>
          <input
            matInput
            (keyup)="filterCustomerVisits($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="customerVisitDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="customerVisitId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            CustomerVisit #
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.customerVisitId | slice : 0 : 8 || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.assignedName || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimator">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.estimator || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Created Date
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{
              customerVisit.createdDate
                ? (customerVisit.createdDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="statusName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.statusName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.customerName || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.jobAddress || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dispositionName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Disposition</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.dispositionName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="subDispositionName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            SubDisposition
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.subDispositionName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dispositionNotes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Disposition Notes
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.dispositionNotes || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dispositionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Disposition Date
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{
              customerVisit.dispositionDate
                ? (customerVisit.dispositionDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="customerVisitDisplayedColumns; sticky: true"
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td
            class="mat-cell"
            [attr.colspan]="customerVisitDisplayedColumns.length"
          >
            No matching customer visits found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: customerVisitDisplayedColumns"
          (click)="goToCustomerVisit(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>

<ng-template #insideSalesTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Customer Visits</mat-label>
          <input
            matInput
            (keyup)="filterCustomerVisits($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="customerVisitDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Created Date
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{
              customerVisit.createdDate
                ? (customerVisit.createdDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.customerName || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.jobAddress || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="discountedTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Proposal Total
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{
              customerVisit.discountedTotal
                ? (customerVisit.discountedTotal | currency)
                : "No Proposal"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimator">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
          <td mat-cell *matCellDef="let customerVisit">
            {{ customerVisit.estimator || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dispositionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Disposition Date
          </th>
          <td mat-cell *matCellDef="let customerVisit">
            {{
              customerVisit.dispositionDate
                ? (customerVisit.dispositionDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="
            availableForInsideSalesDisplayedColumns;
            sticky: true
          "
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td
            class="mat-cell"
            [attr.colspan]="availableForInsideSalesDisplayedColumns.length"
          >
            No matching customer visits found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: availableForInsideSalesDisplayedColumns"
          (click)="goToCustomerVisit(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>

<ng-template #changeOrderTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Change Orders</mat-label>
          <input
            matInput
            (keyup)="filterChangeOrders($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="changeOrderDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="projectid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ProjectId</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.projectid || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Id</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.customerId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobAddressId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Job Address Id
          </th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.jobAddressId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="discountedTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.discountedTotal | currency : "USD" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.assignedName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Created Date
          </th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.createdDate | date : "shortDate" : "UTC" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.description || "n/a" }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="changeOrderDisplayedColumns; sticky: true"
        ></tr>
        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td
            class="mat-cell"
            [attr.colspan]="changeOrderDisplayedColumns.length"
          >
            No pending change orders found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: changeOrderDisplayedColumns"
          (click)="goToChangeOrder(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>
